module.exports = __webpack_public_path__ + "img/center-icon.8ee00375.png";